module.exports = __webpack_public_path__ + "img/mt.80ed8eed.svg";